<script setup lang="ts">
import VText from '~/components/ui/VText.vue'

import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import type { Influencer } from '~/types/influencer'

type Props = {
  influencer: Influencer
}

defineProps<Props>()

const { getMediaUrl } = useGetMediaUrl()
</script>
<template>
  <div
    v-if="influencer.groover_note"
    class="tw-relative tw-w-full tw-rounded-xs tw-bg-orange-100 tw-px-6 tw-py-4"
  >
    <div class="tw-absolute -tw-left-md -tw-top-md tw-size-3xl">
      <img
        :src="getMediaUrl('GrooverNoteLogo2.svg')"
        alt=""
        class="tw-h-full tw-w-full tw-object-contain"
      />
    </div>
    <VText cfg="sans/16/medium" color="orange-500" class="tw-mb-2 tw-block">{{
      $t('influencer.profile.slug.grooverNote.title')
    }}</VText>
    <VText cfg="sans/14/normal" color="black">{{
      $t(`influencer.grooverNote.${influencer.groover_note}`)
    }}</VText>
  </div>
</template>
